import { render, staticRenderFns } from "./table-sale.vue?vue&type=template&id=38b4cf38&scoped=true"
import script from "./table-sale.vue?vue&type=script&lang=js"
export * from "./table-sale.vue?vue&type=script&lang=js"
import style0 from "./table-sale.vue?vue&type=style&index=0&id=38b4cf38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4cf38",
  null
  
)

export default component.exports